import { bindRequestLogic } from './utils'
import ShowcaseAnonymizeVisitor from '../actionTypes/showcaseAnonymizeVisitor'
import { showcaseAnonymizeVisitorAPI } from '../api'

const getAnonymizedVisitors = bindRequestLogic({
  clientFunc: showcaseAnonymizeVisitorAPI.getAnonymizedVisitors,
  type: ShowcaseAnonymizeVisitor.GET_ANONYMIZE_VISITOR_REQUEST,
  successType: ShowcaseAnonymizeVisitor.GET_ANONYMIZE_VISITOR_SUCCESS,
  failType: ShowcaseAnonymizeVisitor.GET_ANONYMIZE_VISITOR_FAILED,
  isQueryParam: true
})

const cancelAnonymizeVisitor = bindRequestLogic({
  clientFunc: showcaseAnonymizeVisitorAPI.cancelAnonymizeVisitor,
  type: ShowcaseAnonymizeVisitor.CANCEL_ANONYMIZE_VISITOR_REQUEST,
  successType: ShowcaseAnonymizeVisitor.CANCEL_ANONYMIZE_VISITOR_SUCCESS,
  failType: ShowcaseAnonymizeVisitor.CANCEL_ANONYMIZE_VISITOR_FAILED,
  isQueryParam: false
})
export default [getAnonymizedVisitors, cancelAnonymizeVisitor]
